export enum TrackingCategory {
  Audio = 'audio',
  Link = 'link',
  Feature = 'feature',
  Filter = 'filter',
  Impression = 'impression',
  Search = 'search',
  SelectableSearch = 'configurator_search'
}
